import * as React from 'react';

import * as Styled from './divider.styles';
import type { DividerProps } from './divider.types';

export const Divider = React.forwardRef<HTMLHRElement, DividerProps>(
  ({ ariaHidden = false, className, ...props }, forwardedRef) => (
    <Styled.Divider
      aria-hidden={ariaHidden}
      className={className}
      data-xds="Divider"
      ref={forwardedRef}
      role="separator"
      {...props}
    />
  )
);

Divider.displayName = 'Divider';
